import { render, staticRenderFns } from "./GestionTypePiece.vue?vue&type=template&id=56f4c684"
import script from "./GestionTypePiece.vue?vue&type=script&lang=js"
export * from "./GestionTypePiece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports